import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, ToastsTitle } from "../../../Constants/Constants";
import LiveToast from "./LiveToast";
import ColorsScheme from "./ColorsScheme";
import StackingToasts from "./StackingToasts";
import TranslucentToasts from "./TranslucentToasts";
import DefaultToast from "./DefaultToast";
import UniqueToast from "./UniqueToast";
import ToastPlacement from "./ToastPlacement";

const ToastsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ToastsTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <LiveToast />
          <ColorsScheme />
          <StackingToasts />
          <TranslucentToasts />
          <DefaultToast />
          <UniqueToast />
          <ToastPlacement />
        </Row>
      </Container>
    </>
  );
};
export default ToastsContainer;
